function isDeprecatedOffering(offering) {
    return 'action' in offering;
}
var CartDiscountValueType;
(function(CartDiscountValueType) {
    CartDiscountValueType["relative"] = "relative";
    CartDiscountValueType["abslute"] = 'absolute';
    CartDiscountValueType["giftLineItem"] = "giftLineItem";
})(CartDiscountValueType || (CartDiscountValueType = {}));
var CartDiscountTargetType;
(function(CartDiscountTargetType) {
    CartDiscountTargetType["lineItems"] = "lineItems";
    CartDiscountTargetType["customLineItems"] = "customLineItems";
    CartDiscountTargetType["shipping"] = "shipping";
})(CartDiscountTargetType || (CartDiscountTargetType = {}));
var StackingMode;
(function(StackingMode) {
    StackingMode["Stacking"] = "Stacking";
    StackingMode["StopAfterThisDiscount"] = "StopAfterThisDiscount";
})(StackingMode || (StackingMode = {}));
/**
 * Contains info about the customer's prescription and relatedly
 * about their status with the OpCo (existing/new/...).
 */ const EXISTING_CUSTOMER = 'ExistingCustomer';
const NEW_PRESCRIPTION = 'NewPrescription';
const PRESCRIPTION_FILE = 'PrescriptionFile';
const EMAIL_PRESCRIPTION = 'EmailPrescription';
function isExistingCustomer(prescription) {
    return (typeof prescription === 'string' ? prescription : prescription === null || prescription === void 0 ? void 0 : prescription.type) === EXISTING_CUSTOMER;
}
function isNewPrescription(prescription) {
    return (typeof prescription === 'string' ? prescription : prescription === null || prescription === void 0 ? void 0 : prescription.type) === NEW_PRESCRIPTION;
}
function isPrescriptionFile(prescription) {
    return (typeof prescription === 'string' ? prescription : prescription === null || prescription === void 0 ? void 0 : prescription.type) === PRESCRIPTION_FILE;
}
function isEmailPrescription(prescription) {
    return (typeof prescription === 'string' ? prescription : prescription === null || prescription === void 0 ? void 0 : prescription.type) === EMAIL_PRESCRIPTION;
}
function isPrescriptionType(prescription) {
    return [
        isExistingCustomer,
        isNewPrescription,
        isPrescriptionFile,
        isEmailPrescription
    ].some((typeCheck)=>typeCheck(prescription)
    );
}
var ShippingRateInputType;
(function(ShippingRateInputType) {
    ShippingRateInputType["Classification"] = "Classification";
    ShippingRateInputType["Score"] = "Score";
})(ShippingRateInputType || (ShippingRateInputType = {}));
/**
 * Product type type guards
 */ const isLenses = (type)=>(typeof type === 'string' ? type : type.productType) === 'Contact-lenses'
;
const isFrames = (type)=>(typeof type === 'string' ? type : type.productType) === 'Frames'
;
const isSunglasses = (type)=>(typeof type === 'string' ? type : type.productType) === 'Sunglasses'
;
const isSolutions = (type)=>(typeof type === 'string' ? type : type.productType) === 'Solutions'
;
const isReadyReaders = (type)=>(typeof type === 'string' ? type : type.productType) === 'Ready-readers'
;
const isAccessories = (type)=>(typeof type === 'string' ? type : type.productType) === 'Accessories'
;
const isContactLensBundle = (type)=>(typeof type === 'string' ? type : type.productType) === 'Contact-lens-bundles'
;
const isAdditionalCartCosts = (type)=>(typeof type === 'string' ? type : type.productType) === 'Additional-cart-costs'
;
const isProductTypeName = (productTypeName)=>isLenses(productTypeName) || isFrames(productTypeName) || isSunglasses(productTypeName) || isSolutions(productTypeName) || isContactLensBundle(productTypeName) || isReadyReaders(productTypeName) || isAccessories(productTypeName)
;
const isProductWithAFrame = (type)=>isSunglasses(type) || isFrames(type) || isReadyReaders(type)
;
/**
 * Line item type guards
 */ const isPrescriptionGlassesLineItem = (lineItem)=>'type' in lineItem && lineItem.type === 'prescription-glasses-line-item'
;

export { isAccessories, isAdditionalCartCosts, isContactLensBundle, isDeprecatedOffering, isEmailPrescription, isExistingCustomer, isFrames, isLenses, isNewPrescription, isPrescriptionFile, isPrescriptionGlassesLineItem, isPrescriptionType, isProductTypeName, isProductWithAFrame, isReadyReaders, isSolutions, isSunglasses };
//# sourceMappingURL=commerce-tools-api.js.map
